export const OUTFIT_QVM_TOP_SLOT_TREATMENT = 1; // QVM - Quick View Modal
export const OUTFIT_QSM_TOP_SLOT_TREATMENT = 2; // QSM - Quick Shop Modal (STL)
export const OUTFIT_QVM_TREATMENT = 3;
export const OUTFIT_QSM_TREATMENT = 4;
export const MSA_IMAGE_DIMENSIONS = { width: 400, height: 400 };
export const OUTFIT_RECO_REF_TAG = 'outfit-reco';

export const INLINE_OUTFIT_RECO_HEIGHT = 80;
export const DISPLAY_OUTFIT_COUNT = 4;
